import "./Spinner.css";

export default function Spinner() {
  return (
    <div className="Spinner__container">
      <span className="loader"></span>
      <p>Cargando turnos...</p>
    </div>
  );
}
